/* global $ */
import { TweenMax } from 'gsap';

import { createElement, Component } from 'rlink-react';
import NavLink from 'rlink-router/NavLink';
import { HASH } from 'rlink-router/constants';
import themeable from 'rlink-theme/themeable';

import getArticleLoader from 'helpers/getArticleLoader';

export default class CandidateNotice extends Component {
  componentWillUpdate (_nextProps, _nextState) {
    TweenMax.delayedCall(1, () => {
      $('.ajax-node').show();
      this.loaderObj.hide();
    });
  }

  showLoaderCallback () {
    $('.ajax-node').hide();
    TweenMax.delayedCall(0.5, () => {
      let $existingNode = $('.ajax-node');
      if ($existingNode.length) {
        TweenMax.delayedCall(1, () => {
          $existingNode.show();
          this.loaderObj.hide();
        });
      }
    });
  }

  componentDidMount () {
    if (typeof document !== 'undefined') {
      $('html').addClass('candidate-notice');
      this.loaderObj = getArticleLoader();

      // show() returns false if already showing and undefined if not showing
      // In the case where it returns false the callback is not run.
      let didShowTrigger = this.loaderObj.show(() => {
        this.showLoaderCallback();
      });
      if (didShowTrigger === false) {
        this.showLoaderCallback();
      }

    }
  }

  onClose () {
    this.loaderObj.show(() => {
      TweenMax.delayedCall(1.0, () => {
        $('.ajax-node').hide();
        this.loaderObj.hide();
        $('html').removeClass('candidate-notice');
        $(window).trigger('scroll-careers');
      });
    });
  }

  render () {
    let {theme} = this.props;
    return (
      <div className={theme.Container}>
        <div className={theme.ArticleWrapper}>
          <article className={theme.Article}>
            <div className="body field">
              <h2>Application for Employment and/or Temporary/Agency Work (the “Notice”)</h2>
              <p>Relic Entertainment Inc. (“Relic”) is committed to protecting and respecting your privacy. 
                We will treat your personal data confidentially and will comply with The Personal Information Protection 
                and Electronic Documents Act, and applicable legislation enacted from time to time relating to data 
                privacy and protection (together, the “Data Protection Legislation”) in respect of our processing activities.</p>
                <p>Relic is the data controller responsible for collecting and using your personal data. </p>
              <p>By applying for employment at Relic, you agree to the processing
                by Relic and our applicant processing partner,
                BambooHR, Inc., (“<strong>BambooHR</strong>”) of your personal data and
                you acknowledge that you have read and understood the following:</p>
              <h3>Information we collect from you</h3>
              <p>The types of personal data that we may collect directly from you
                include, but are not limited to, your first and last name, contact
                information, and career history data. Where you provide consent,
                we may also refer to information set out in your LinkedIn profile
                when considering your application. </p>
                <p>You may be required to complete an assessment as you progress
                  through the recruitment process. You will be provided with information
                  about the assessment requirements in advance. </p>
              <h3>Pre-employment screening</h3>
              <p>We will always seek to limit the amount of personal data that we
                collect from you to what is required in accordance with applicable
                law and with your consent, in order to enable you to progress through
                the recruitment process.</p>
              <h3>How we use your information</h3>
              <p>As part of your application for temporary work and/or employment
                at Relic, the data you provide, and/or personal data provided on
                your behalf by one of our recruitment partners (such as a recruitment agency),
                including that from any interviews and assessments, will be held
                on our computers, the BambooHR platform, or manually in our files.
                The data will be used by Relic to process your application and
                ultimately, where your application is successful, so that Relic
                can make you an offer of temporary work and/or employment.  </p>
              <p>We do not use automated decision making as part of our recruitment
                process. All recruitment decisions for roles at Relic are made by
                the hiring manager and members of our recruitment team who assess
                your suitability for employment. We will send you the results of your
                application at the e-mail address that you have provided to Relic.
                Due to the high level of applications that we receive,
                we may not be able to provide individual feedback to unsuccessful
                candidates. </p>
                <p>We take security very seriously and we use appropriate physical,
                  technical and organizational security measures to help safeguard
                  your personal data and protect against unauthorised access,
                  accidental loss, destruction and/or damage.  </p>
              <h3>Processing your information</h3>
              <p>Relic uses a third-party solution (BambooHR, Inc.) to administer the
                recruitment processes online. You can find information about how
                BambooHR, Inc. processes your personal information&nbsp;
                <a rel="noopener"
                  className={theme.BodyLink}
                  target="_blank"
                  href="https://www.bamboohr.com/legal/privacy-policy">here</a>.
              </p>
              <h3>Retention of recruitment records</h3>
              <p>If your application is successful, we will move your recruitment
                information to your employment files. We will only move data that
                is relevant to your ongoing employment at Relic. Once you are
                employed at Relic, your personal data is governed in accordance
                with the staff privacy policy and, if applicable, your employment
                contract. Where you are recruited as a temporary agency worker,
                we will only process your personal data in relation to the agency
                work and/or services you provide for Relic. </p>
              <p>If your application is unsuccessful, application documentation
                will be kept on file for twenty-four (24) months from your application
                date, so that Relic may contact you in respect of future vacancies
                that may be of interest to you. Relic will also retain your personal
                data as needed to comply with any legal or document retention obligations.</p>
              <p>If you do not wish for Relic and/or BambooHR to continue to process
                your personal data in the ways described in this Notice, you can
                request this through a dedicated link available through BambooHR
                platform, or by contacting us in writing at&nbsp;
                <a rel="noopener" className={theme.BodyLink} target="_blank" href="mailto:dpo@relic.com">dpo@relic.com</a>.</p>
              <p>Once your personal data is no longer needed, we will dispose of
                your records in a secure manner and in accordance with our records
                management policies.</p>
              <h3>Your rights</h3>
              <p>You have certain rights in relation to the personal data that
                we hold about you. If you wish to exercise your right to access,
                update, erase and/or correct personal data which you have submitted
                to Relic as part of the recruitment process, you can request this
                through the BambooHR platform. We will comply with your request(s)
                as soon as reasonably practicable, consistent with applicable law.
                Note, in limited cases where permitted, we may charge a fee for data
                access requests. </p>
              <p>If you have any further questions, please contact: Data Protection Officer, Relic Entertainment Inc., 500 – 285 West 5th Avenue, Vancouver BC, V5Y 1J3.</p>
              <p>If you remain unhappy with a response you receive from us, you can also refer the matter to your data protection supervisory
                authority:&nbsp;
                <a rel="noopener" className={theme.BodyLink} target="_blank" href="https://www.priv.gc.ca/en/">https://www.priv.gc.ca/en/</a>
              </p>
            </div>
            <ul className={theme.Pagination}>
              <li className={theme.PaginationClose}>
                <NavLink
                  className={theme.CloseLink}
                  href={{
                    view: 'home',
                    params: { [HASH]: '#careers' },
                  }}
                  onClick={() => this.onClose()}>✕</NavLink>
              </li>
            </ul>
          </article>
        </div>
      </div>
    );
  }
}

themeable(CandidateNotice, {
  classes: [
    'Container',
    'BodyLink',
    'ArticleWrapper',
    'Article',
    'Pagination',
    'PaginationClose',
    'CloseLink',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/CandidateNotice.jsx